/** Global Configurations */
const appMode = 'live'; // either dev or live
export let apiURI = '';
export let mainSite = '';
export const showDebugInfo = true; // flag to show debugging information on the screen
export const warmUpActivityId = '27';

export const updateCheckProperties = {
  versionInt: 10406,
  updateVersionCheckURL: 'https://mobileapps.pivotcreates.com',
  playStoreLink:
    'market://details?id=com.ehouston.cerebrocoreclientworkoutdashboard',
  iTunesStoreLink: 'itms://itunes.apple.com/app/id6449496314',
  updateCheckRedirectFile: 'checkminversion/redirect.json',
  updateCheckFile: 'checkminversion/cerebrocore.json',
  updateCheckWaitHours: 12,
};

export const PivotLoggingConfig = {
  modulesToLog: {
    logEverything: true,

    modules: ['TodaysWorkout', 'WorkoutDasboard', 'GameView'],

    notifyPoint: [],
  },

  modulesToExclude: {},
};

// set values based on if the app is in dev mode or live
if ('dev' === appMode) {
  apiURI =
    'https://dev.cerebrocoreusa.com/wp-content/plugins/advanced-healthcare-solutions/ajax';
  mainSite = 'https://dev.cerebrocoreusa.com';
} else {
  apiURI =
    'https://cerebrocoreusa.com/wp-content/plugins/advanced-healthcare-solutions/ajax';
  mainSite = 'https://cerebrocoreusa.com';
}
